import Link from '@Components/common/Link';
import Image from 'next/image';
import { AddButton, AddCar, Icon, P, Title, Wrapper } from './Empty.styled';
type Props = {
  icon?: string | any;
  title?: string;
  addLabel?: string;
  onAdd?: any;
  noSpace?: boolean;
};

export default function Empty({ icon, title, addLabel, onAdd, noSpace }: Props) {
  return (
    <Wrapper smallSpace={noSpace}>
      <Icon>
        <Image src={icon} width={154.35} height={135.06} alt="car" />
      </Icon>
      <Title>{title}</Title>
      <AddCar onClick={onAdd}>
        {onAdd && <AddButton>+</AddButton>}
        <P as={onAdd ? 'p' : Link} href="/">
          {addLabel}
        </P>
      </AddCar>
    </Wrapper>
  );
}
